<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 v-if="open" class="modal-title">列印{{ sendTypeName }}專函-{{ custData.ceapcnm }}</h3>
        </div>
        <div v-if="open" class="modal-body send-modal-body" :class="{'section-loading': sendLoading}">
          <div class="font-weight-bold">您目前正在列印保戶 <span class="text-green">{{ custData.ceapcnm }}</span> 的聯繫單</div>
          <ol class="pl-3 sub-ol">
            <li>拜訪前 <br />
              服務聯繫專函包含契約資料一覽與聯繫專函正文，提醒您務必選取「<span class="text-red">雙面列印</span>」。
            </li>
            <li>拜訪中
              <ol class="p-0">
                <li>第1面為保戶由您所服務之契約資料一覽，建議您可搭配保單健檢服務，提供保戶更完整之保障內容。</li>
                <li>第2面為保戶服務聯繫專函(分親送/郵寄版)，通知保戶相關權益，可留給保戶作為參考。</li>
                <li>建議您拜訪前同時攜帶「電子單據/行動服務申請書(業務員代送專用)」，便利保戶同時開通電子單據與行動服務。</li>
              </ol>
            </li>
            <li>完成拜訪後 <br />
              您只要完成實質接觸項目，都計入績效認定。
            </li>
          </ol>
          <div>如同仁對於活動辦法有任何問題，請洽總公司<span class="text-red">業務部業務企劃科(02)27551399#{{ this.$store.state.serviceLine }}</span>。<br />
          <span class="text-green">(注意：列印PDF時，請於列印設定之「頁面處理」/「頁面縮放」選擇「無」之後再列印)</span></div>
          <div class="action text-right mt-2">
            <a @click.prevent="submit()" class="btn btn-primary">
              列印{{ sendTypeName }}專函
            </a>
          </div>
        </div>
         <form v-show="false" name='form_A' :action="postUrl" method='post' target="_blank" accept-charset="big5" onsubmit="document.charset = 'big5'">
          <span>資料(json) :  </span>
          <input name='FORMDATA' :value="List"><br>

          <span>聯繫單樣式 :  </span>
          <input name='PRINT_SE' :value="sendtype"><br>

          <span>聯繫單編號 :  </span>
          <input name='VISIT_NO' :value="custData.visit_no"><br>

          <span>要保人姓名 :  </span>
          <input name='CS_NAME' :value="formData.ceapcnm"><br>

          <span>客戶生日 :  </span>
          <input name='CS_BIRTH' :value="formData.cs_birth ? dateFormat(formData.cs_birth) : ''"><br>

          <span>客戶電話 :  </span>
          <input name='CS_TEL' :value="formData.cs_tel"><br>

          <span>客戶手機 :  </span>
          <input name='CS_MOBILE' :value="formData.cs_mobile"><br>

          <span>客戶地址 :  </span>
          <input name='CS_ADDR' :value="formData.cs_addr"><br>

          <span>客戶郵遞區號 :  </span>
          <input name='CS_ZIP' :value="formData.cs_zip"><br>

          <span>是否申辦電子單據 :  </span>
          <input name='CS_EBILLS' :value="formData.ebills"><br>

          <span>客戶email :  </span>
          <input name='CS_EMAIL' :value="formData.csemail"><br>

          <span>業務員姓名 :  </span>
          <input name='AG_NAME' :value="formData.name"><br>

          <span>單位代號 :  </span>
          <input name='AG_CEDVNO' :value="formData.div_no"><br>

          <span>單位區處名稱 :  </span>
          <input name='AG_CEDVNM' :value="formData.cedvnm"><br>

          <span>單位經理姓名 :  </span>
          <input name='AG_MANAGER' :value="formData.div_info.mgr_name"><br>
          
          <span>單位地址 :  </span>
          <input name='AG_ADDR' :value="formData.div_info.addr"><br>

          <span>單位電話 :  </span>
          <input name='AG_TEL' :value="formData.div_info.phone_01"><br>

          <span>單位名稱 :  </span>
          <input name='AG_CEDVNM4' :value="formData.div_info.cedvnm4"><br>

          <span>契約截至日期(年) :  </span>
          <input name='PRINT_YEAR' 
          :value="formData.print_day ? (formData.print_day.split('-')[0] * 1 - 1911 + '') : ''"><br>

          <span>契約截至日期(月) :  </span>
          <input name='PRINT_MONTH' :value="formData.print_day ? formData.print_day.split('-')[1] : ''"><br>

          <span>契約截至日期(日) :  </span>
          <input name='PRINT_DAY' :value="formData.print_day ? formData.print_day.split('-')[2] : ''"><br>

          <span>當前日期(年) :  </span>
          <input name='NOW_YEAR' :value="nowDate.nowYear"><br>

          <span>當前日期(月) :  </span>
          <input name='NOW_MONTH' :value="nowDate.nowMonth"><br>

          <span>當前日期(日) :  </span>
          <input name='NOW_DAY' :value="nowDate.nowDay"><br>

          <div v-for="(mainItem, index) in formData.visit_main" :key="`form-${index}`">
             <!--最多傳10筆 -->
            <div v-if="index < 10">
              <span>被保人姓名_遮碼 :  </span>
              <input :name="`MAIN_A${index + 1}`" :value="mainItem.m_ceisdnm"><br>
              <span>投保日期 :  </span>
              <input :name="`MAIN_B${index + 1}`" :value="mainItem.ceplcdt? dateFormat(mainItem.ceplcdt): ''"><br>
              <span>險別名稱 :  </span>
              <input :name="`MAIN_C${index + 1}`" :value="mainItem.plan_name"><br>
              <span>保單號碼_遮碼 :  </span>
              <input :name="`MAIN_D${index + 1}`" :value="mainItem.m_plcno"><br>
              <span>保額 and 保額單位:  </span>
              <input :name="`MAIN_E${index + 1}`" :value="mainItem.m_plcno? numFormat(mainItem.cesumi, mainItem.pl_unit) : ''"><br>
              <span>契約效力(中文) :  </span>
              <input :name="`MAIN_F${index + 1}`" :value="mainItem.celpscs_nm"><br>
              <span>繳別(中文) :  </span>
              <input :name="`MAIN_G${index + 1}`" :value="mainItem.cepaymd_nm"><br>
              <span>繳費方式(中文) :  </span>
              <input :name="`MAIN_H${index + 1}`" :value="mainItem.celpscs_nm == '正常'? mainItem.pay_type_nm : ''"><br>
            </div>
          </div>

          <div v-for="(subItem, index) in formData.visit_sub" :key="`form-sub-${index}`">
            <!-- 最多傳10筆-->
            <div v-if="index < 30">
              <span>被保人姓名_遮碼 :  </span>
              <input :name="`SUB_A${index + 1}`" :value="subItem.m_cename"><br>
              <span>保單號碼_遮碼 :  </span>
              <input :name="`SUB_B${index + 1}`" :value="subItem.m_plcno"><br>
              <span>險別名稱 :  </span>
              <input :name="`SUB_C${index + 1}`" :value="subItem.plan_name"><br>
              <span>保額 and 保額單位 :  </span>
              <input :name="`SUB_D${index + 1}`" :value="subItem.cerdamt? numFormat(subItem.cerdamt, subItem.pl_unit) : ''"><br>
            </div>
          </div>



          <button type="submit" id="sendSubmit">點擊送出</button>

        </form> 
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getChangePrint, getCustIAA, showChangePDF } from "@/service";

export default {
  name: 'SendModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    sendtype: {
        type: String,
        default: ''
    },
    custData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.initSend() // 初始化
      }
    },
  },
  data() {
    return {
      sendLoading: false,
      formData: {
        div_info: {},
        visit_main: [],
        visit_sub: [],
      },
      postUrl: '',
      nowDate: {
        nowYear: '',
        nowMonth: '',
        nowDay: '',
      },
      sendTypeName: '',
      List:[],
      sendUrl: "crms/ProReport/servlet/servlets.ServiceContactForm" //報表路徑
    }
  },
  methods: {
    initSend () { // 初始化
      this.registerHanlink();
      if(this.sendtype=='1' || this.sendtype=='4' ||  this.sendtype=='6'){
        this.sendTypeName = '親送'
      }else{
         this.sendTypeName = '郵寄'
      }
    },
    numFormat (num = 0, unit = '') { // 組合保額 and 保額單位
      let number = Number(num) 
      if (number >= 10000) {
        number = ( number / 10000 ).toFixed(1) + ''
        number = number.replace(/\.0/, '') // (四捨五入到小數點後1位，小數為0則省略，例：3.5萬元、2萬元)
        return number + '萬' + unit
      } else {
        return number + '' + unit
      }
    },
    dateFormat (val) {  // 轉換為民國
      if(val) {
        let dataAry = val.split('-')
        dataAry[0] = dataAry[0] * 1 - 1911 + ''
        return dataAry.join('-')
      } else {
        return ''
      }
    },
    async submit() {
      this.sendLoading = true;
      this.List = [];
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      }
      const res = await getChangePrint(
        this.$store.state.userInfo.id,
        this.custData.ceapcno,
        this.custData.visit_no,
        this.$store.state.userInfo.divNo
      );
      this.sendLoading = false;
      if (!res.header || res.header.status !== "200") {
        return;
      }
      this.sendLoading = true;
      const result = await getCustIAA(
        this.$store.state.userInfo.id,
        this.custData.ceapcno,
        "queryAPI"
      );
      this.sendLoading = false;
      let cs_mobile = "";
      let cs_tel = "";
      if (
        result.header &&
        result.header.status === "200" &&
        result.body &&
        result.body.detail
      ) {
        const detail = result.body.detail;
        cs_mobile = detail.mobl_no || "";
        cs_tel =
          (detail.htel_area || "") +
          (detail.htel_num || "") +
          (detail.htel_ext ? "#" + detail.htel_ext : "");
      }
      const print_data = res.body.print_data;
      print_data.cs_mobile = cs_mobile;
      print_data.cs_tel = cs_tel;
      this.formData = print_data;
      this.List.push(print_data);
      this.List = JSON.stringify(this.List);

      const param = {};
      param["FORMDATA"] = this.List || "";
      param["PRINT_SE"] = this.sendtype || "";
      param["VISIT_NO"] = this.custData.visit_no || "";
      param["CS_NAME"] = this.formData.ceapcnm || "";
      param["CS_BIRTH"] = this.formData.cs_birth
        ? this.dateFormat(this.formData.cs_birth)
        : "";
      param["CS_TEL"] = this.formData.cs_tel || "";
      param["CS_MOBILE"] = this.formData.cs_mobile || "";
      param["CS_ADDR"] = this.formData.cs_addr || "";
      param["CS_ZIP"] = this.formData.cs_zip || "";
      param["CS_EBILLS"] = this.formData.ebills || "";
      param["CS_EMAIL"] = this.formData.csemail || "";
      param["AG_NAME"] = this.formData.name || "";
      param["AG_CEDVNO"] = this.formData.div_no || "";
      param["AG_CEDVNM"] = this.formData.cedvnm || "";
      param["AG_MANAGER"] = this.formData.div_info.mgr_name || "";
      param["AG_ADDR"] = this.formData.div_info.addr || "";
      param["AG_TEL"] = this.formData.div_info.phone_01 || "";
      param["AG_CEDVNM4"] = this.formData.div_info.cedvnm4 || "";
      param["PRINT_YEAR"] = this.formData.print_day
        ? this.formData.print_day.split("-")[0] * 1 - 1911 + ""
        : "";
      param["PRINT_MONTH"] = this.formData.print_day
        ? this.formData.print_day.split("-")[1]
        : "";
      param["PRINT_DAY"] = this.formData.print_day
        ? this.formData.print_day.split("-")[2]
        : "";

      this.formData.visit_main.forEach((item, index) => {
        param["MAIN_A" + (index + 1)] = item.m_ceisdnm || "";
        param["MAIN_B" + (index + 1)] = item.ceplcdt
          ? this.dateFormat(item.ceplcdt)
          : "";
        param["MAIN_C" + (index + 1)] = item.plan_name || "";
        param["MAIN_D" + (index + 1)] = item.m_plcno || "";
        param["MAIN_E" + (index + 1)] = item.m_plcno
          ? this.numFormat(item.cesumi, item.pl_unit)
          : "";
        param["MAIN_F" + (index + 1)] = item.celpscs_nm || "";
        param["MAIN_G" + (index + 1)] = item.cepaymd_nm || "";
        param["MAIN_H" + (index + 1)] =
          item.celpscs_nm == "正常" ? item.pay_type_nm : "";
      });

      this.formData.visit_sub.forEach((item, index) => {
        const sub_A = item.m_cename || "";
        const sub_B = item.m_plcno || "";
        const sub_C = item.plan_name || "";
        const sub_D = item.cerdamt
          ? this.numFormat(item.cerdamt, item.pl_unit)
          : "";
        param["SUB_A" + (index + 1)] = sub_A;
        param["SUB_B" + (index + 1)] = sub_B;
        param["SUB_C" + (index + 1)] = sub_C;
        param["SUB_D" + (index + 1)] = sub_D;
      });

      const pdfResult = await showChangePDF(
        this.$store.state.userInfo.id,
        param
      );

      if (this.isBox) {
        this.boxSendBase64PdfData(new Uint8Array(pdfResult.file));
      } else {  
        const file = new Blob([new Uint8Array(pdfResult.file)], {
          type: "application/pdf"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "post.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
      }

      this.$emit("close");
    }
  },
  mounted () {
    //  post網址
    // 'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    let href = window.location.href
    if(href.includes('://mycrm')){  // 正式環境
      this.postUrl = 'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    } else if (href.includes('://smycrm')) {  // 平測環境
      this.postUrl = 'https://sw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    } else {  // local & 測試環境
      this.postUrl = 'https://tw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    }

    //  紀錄當前系統時間
    const nowD = new Date()
    this.nowDate.nowYear = nowD.getFullYear() - 1911 + ''
    this.nowDate.nowMonth = nowD.getMonth() + 1 + ''
    this.nowDate.nowDay = nowD.getDate() + ''
    if(this.nowDate.nowMonth.length == 1) {this.nowDate.nowMonth = '0' + this.nowDate.nowMonth}
    if(this.nowDate.nowDay.length == 1) {this.nowDate.nowDay = '0' + this.nowDate.nowDay}
  },
}
</script>
